import { Price } from './api/types';

export function formatPrice({ amount, currency }: Price): string {
  return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);
}
